function fn_layout_header() {
	$('[data-header-search]').on('click', function(e) {
        if(!$(this).hasClass('icon-active')) {
            e.preventDefault();
        }
		$('.absolute-search input').fadeIn(400).focus();
		$('.absolute-search button').addClass('icon-active');
	});

	$('.cart-toggle').on('click', function() {
		$('.cart-toggle-content').fadeToggle(200);
	});

	$('nav').slideAndSwipe();
}